import { styled } from 'styled-components';

export const MoreLayout = styled.div`
  width: 2.4375rem;
  height: 0.9375rem;
  border-radius: 1.875rem;
  background: #fff;
  box-shadow: 0px 0px 2px 0px #c2ced5;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.255rem;

  span {
    color: #8d999f;
    font-size: 0.4375rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;
